import { configureStore } from '@reduxjs/toolkit';
import userSlice from '@slices/userSlice';
import productSlice from '@slices/productSlice';
import cryptoSlice from '@slices/cryptoSlice';
import stockSlice from '@slices/stockSlice';

export default configureStore({
    reducer: {
        user: userSlice,
        product: productSlice,
        crypto: cryptoSlice,
        stock: stockSlice,
    }
});